<template>
  <div :id="id"></div>
</template>

<script>
// EditorSummernote
import AppNative from '@/assets/utils/AppNative';

var _toolbar_pc = [
  ['style', ['style']],
  ['font', ['bold', 'underline', 'clear']],
  ['fontname', ['fontname']],
  ['color', ['color']],
  ['para', ['ul', 'ol', 'paragraph']],
  ['table', ['table']],
  ['insert', ['link', 'picture', 'video']],
  ['view', ['fullscreen', 'codeview', 'help']],
];

var _toolbar_mobile = [
  ['font', ['bold', 'underline']],
  ['para', ['paragraph']],
  ['insert', ['link', 'picture', 'video']],
  ['view', ['fullscreen']],
];

export default {
  name : 'EditorSummernote',

  props : {
    value : { default : null },
    id : { default : 'summernote_id_default' },
    minHeight: { default : '60px' }
  },

  data() {
    return {
      inited : false
    }
  },

  watch : {
    value ( _new, _old ) {
      // console.log('#43 watch value', _new, _old, this);

      if ( !_old ) {
        this.summernoteSetCode(_new); // 赋值
      }
    }
  },

  created() {
    // console.log('#50 created', this);
  },

  mounted() {
    // console.log('#54 mounted', this);

    var _this = this;

    // 初始化
    this.initSummernote();

    this.listenKeyup();

    if(!!this.value) {
      this.summernoteSetCode(this.value); // 赋值
    }
  },

  methods: {
    listenKeyup() {
      window.addEventListener('keyup', e => {
        if ( e.target.classList.contains('note-editable') && '@' == e.key ) {
          _this.win(e);
          return;
        }

        if ( e.target.classList.contains('note-editable') && '#' == e.key ) {
          _this.win(e);
          return;
        }
      });
    },

    // 计算文本宽度
    textWidth ( text ) {
      var _span = document.createElement("span");
      var _offsetWidth = _span.offsetWidth;

      _span.style.visibility = "hidden";
      _span.style.display = "inline-block";

      document.body.appendChild(_span);

      if( typeof _span.textContent != "undefined" ){
        _span.textContent = text;
      } else {
        _span.innerText = text;
      }

      var width = parseFloat(window.getComputedStyle(_span).width) - _offsetWidth;

      document.body.removeChild(_span);

      return width;
    },

    win(e) {
      var range = window.getSelection().getRangeAt(0);
      var endContainer = range.endContainer;

      var rect = endContainer.parentElement.getBoundingClientRect();

      // TODO 什么时候 自动隐藏掉框框
      var innerText = endContainer.parentElement.innerText;
      var textWidth = this.textWidth(innerText);

      var win_0 = document.getElementById('win_0');

      // 改变位置
      if ( !!win_0 ) {
        win_0.style.left = rect.left + textWidth + "px";
        win_0.style.top = rect.bottom + "px";
        return;
      }

      // 创建
      var style = `
        z-index:99999;
        position:fixed;
        left:${rect.left + textWidth}px;
        top:${rect.bottom}px;
        background:rgba(37, 38, 45, 0.1);
        width:200px;
        height:200px;
      `;

      var div = document.createElement('div');
      div.setAttribute('id', 'win_0');
      div.setAttribute('style', style);

      div.innerHTML = '<p>实验<br/><br/>@某人<br/><br/>#某个工单<br/><br/>点我关闭</p>';

      div.onclick = () => {
        div.remove();
      };

      document.body.appendChild(div);
    },

    summernoteGetCode() {
      if ( !this.inited ) {
        console.log('#47 summernoteGetCode not inited', this);
        return;
      }

      return $("#" + this.id).summernote('code');
    },

    summernoteSetCode( _code ) {
      if ( !this.inited ) {
        // console.log('#55 summernoteSetCode not inited', _code, this);
        return;
      }

      return $("#" + this.id).summernote('code', _code);
    },

    onSummernoteChange( _content ) {
      if ( _content == this.value ) {
        // console.log('#61 onSummernote not change', _content, this.value, this);
        return;
      }

      // console.log('#175 onSummernoteChange', _content, this.value, this);

      this.$emit('input', _content);

      this.$emit('change', _content);
    },

    destroySummernote() {
      $("#" + this.id).summernote('destroy');
    },

    initSummernote() {
      // console.log('#40 initSummernote', this);

      var _this = this;

      $("#" + this.id).summernote({
        toolbar : AppNative.isMobile() ? _toolbar_mobile : _toolbar_pc,

        minHeight: _this.minHeight,

        placeholder: "在这里输入内容",

        callbacks: {
          onImageUpload: function(files) {
            _this.sendFile(files[0]);
          },

          onChange( _content ) {
            _this.onSummernoteChange( _content );
          }
        }
      });

      this.summernoteSetCode(this.value); // 赋值

      this.inited = true;
    },

    summernote() {
      console.log('#89 summernote', ...arguments, this);

      return $("#" + this.id).summernote(...arguments);
    },

    //自定义图片上传方法
    sendFile(file) {
      var _this = this;

      let type = file.name.split(".");
      var data = {
        ext: type[type.length - 1]
      };

      sdk.QiniuApi().qiniuToken({
        suffix : type[type.length - 1]
      }).then(_token => {
        var url = "//upload-z0.qiniup.com";

        var formData = new FormData();
        formData.append("file", file);
        formData.append("key", _token.key);
        formData.append("token", _token.token);

        this.$http.post(url, formData).then(resp => {
          var imageUrl = _token.domain + "/" + resp.data.key;

          $("#" + this.id).summernote("editor.insertImage", imageUrl);
        });
      });
    }
  }
};
</script>

<style>
  .note-editable img {
    max-width: 40vw;
    max-height: 40vw;
  }

  .panel {
    border-radius: 0px;
    margin-bottom: 10px;
  }

  .panel-default > .panel-heading {
    background-color: #FFF;
  }

  .note-editor.note-frame .note-statusbar {
    background-color: #FFF;
  }

  .note-editor.note-frame {
    border: 1px solid #DCDFE6;
  }

  .note-editor.note-frame .note-editing-area .note-editable {
    line-height: 20px;
  }

  .note-editor.note-frame .note-editing-area .note-editable p {
    margin: 0;
  }

  .el-form-item__content {
    line-height: 20px;
  }

  .note-editor.note-frame .note-statusbar .note-resizebar {
    height: 0;
    padding-top: 0;
  }

  .note-editor.note-frame .note-statusbar .note-resizebar .note-icon-bar:last-child {
    display: none;
  }

  .note-editor.note-frame .note-status-output {
    padding-top: 0;
    height: 0;
  }

  .note-editor.note-frame .note-status-output:empty {
    display: none;
  }

  .btn-sm, .btn-group-sm > .btn {
    border-radius: 0;
  }

  .dropdown-menu {
    border-radius: 0;
  }

  .modal-content {
    border-radius: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/EditorSummernote.vue